import type { ChangelogEntry } from "../types";

/** Ansattkortet v2: fanene øverst, egen Nøkkeltall-fane og riktige tall i alle faner. */
export const ANSATTKORTET_V2_2026_10: ChangelogEntry = {
  id: "2026-10-28-ansattkortet-v2",
  date: "2026-10-28",
  title: "Ryddigere ansattkort",
  summary: "Fanene ligger øverst, nøkkeltallene har fått egen fane, og prosjekter, timer og fravær viser riktig status.",
  sections: [
    {
      heading: "Ansatte",
      items: [
        {
          title: "Fanene ligger rett under toppkortet",
          kind: "forbedret",
          body: "Du slipper å scrolle forbi nøkkeltallene for å komme til prosjekter, timer og fravær.",
        },
        {
          title: "Nøkkeltall i egen fane",
          kind: "forbedret",
          minRole: "admin",
          body: "KPI-ene for en ansatt står i fanen Nøkkeltall, som åpner først. Kortene er delt i Lønnsomhet og Timer og salg, med de fem største avsluttede prosjektene under. Klikk på budsjettavvik som salgseier for å se prosjektene.",
        },
        {
          title: "Salgskortet viser GEEK",
          kind: "forbedret",
          minRole: "admin",
          body: "Kortet som het «Salgssum etter eierandel» viser nå GEEK etter eierandel for årets signerte salg: reell GEEK for avsluttede prosjekter og estimert GEEK for pågående. Kansellerte salg teller ikke.",
        },
        {
          title: "Prosjekter viser riktig status",
          kind: "rettet",
          body: "Prosjektlista har filtrene Aktive, Avsluttede og Interne, og statusen kommer fra prosjektets fase. Et avsluttet prosjekt står ikke lenger som aktivt, og slettede prosjekter vises ikke.",
        },
        {
          title: "Timer per uke med ukenummer",
          kind: "rettet",
          body: "Timeloggen viser ukenummer og ukedag, og føringer på søndag havner i riktig uke.",
        },
        {
          title: "Fravær skiller godkjent og ventende",
          kind: "rettet",
          body: "Summen viser godkjent og ventende fravær hver for seg. Hver rad har status, avslått fravær er strøket ut, og varigheten står i arbeidsdager.",
        },
        {
          title: "Faktureringsgrad per måned som stolper",
          kind: "forbedret",
          body: "Mål-fanen viser grad denne måneden, hittil i år og GEEK-bidrag øverst, og hver måned som en stolpe mot målet.",
        },
        {
          title: "Innstillinger med én Rediger-knapp",
          kind: "forbedret",
          body: "Feltene er gruppert i Person, Arbeid og Pris, og du redigerer fra fanen Innstillinger.",
        },
      ],
    },
  ],
};
